const Progress = ({ value }) => {
  const parsed = parseInt(value) || 0;

  return (
    <div className="progress">
      <span className="progress--line" style={{ width: `${parsed}%` }}></span>
      {parsed > 0 && (
        <div
          className="progress--indicator"
          style={{ left: `calc(${parsed}% - 7px)` }}
        >
          <span className="progress--badge">{`${parsed}%`}</span>
        </div>
      )}
    </div>
  );
};

export default Progress;
